import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatDialogModule} from '@angular/material/dialog';
import {SwissDynamicFormComponent} from './swiss-dynamic-form/swiss-dynamic-form.component';
import {ObjektDialogComponent} from './objekt-dialog/objekt-dialog.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {AddressFormFieldContainerComponent} from './advanced-address-field-control/address-form-field-container/address-form-field-container.component';
import {CustomFormFieldControlComponent} from './advanced-address-field-control/custom-form-field-control/custom-form-field-control.component';
import {AskDialogComponent} from './ask-dialog/ask-dialog.component';
import {InputDialogComponent} from './input-dialog/input-dialog.component';
import {WaitDialogComponent} from './wait-dialog/wait-dialog.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpLoaderFactory} from '../app.module';
import {HttpClient} from '@angular/common/http';
import {MatTooltipModule} from '@angular/material/tooltip';
import {SwissDynamicObjectNumberRangeComponent} from './swiss-dynamic-form/swiss-dynamic-object-number-range/swiss-dynamic-object-number-range.component';

@NgModule({
    declarations: [
        SwissDynamicFormComponent,
        SwissDynamicObjectNumberRangeComponent,
        ObjektDialogComponent,
        AddressFormFieldContainerComponent,
        CustomFormFieldControlComponent,
        AskDialogComponent,
        InputDialogComponent,
        WaitDialogComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatCardModule,
        MatInputModule,
        MatFormFieldModule,
        MatRadioModule,
        MatSelectModule,
        MatDialogModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        MatTooltipModule,
        TranslateModule,
    ],
    exports: [
        SwissDynamicFormComponent,
        MatDialogModule,
        MatDatepickerModule
    ],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'de-DE'}
    ]
})
export class SwissFormsModule {
}
